export const PAGE_SIZE = 25;
export const DEFAULT_PAGE_SIZE = 25;
export const HIDE_ON_SINGLE_PAGE = true;
export const PAGE_KEY = "page";
export const ORDERING_KEY = "ordering";
